//Library Imports
import React from "react";
import { useState, useEffect } from "react";
import { Col, Row, Select, Tooltip, Typography, Radio, Input as AntdInput, Modal, Space } from "antd";
import Input from "../../../Common/Components/Input";
import SelectWithIcon from "modules/Campaigns/Shared/SelectWithIcon";
import Checkbox from "../../../Common/Components/Checkbox";
import DownAngle from "../../../../assets/img/icons/DownAngle.svg";
import styled from "styled-components";
import { ReactComponent as Cross } from "../../../../assets/img/icons/cross.svg";
import SmallButton from "modules/Content/Shared/SmallButton";
import { useDispatch, useSelector } from "react-redux";
import { shareProfileConfigurationModal, saveShareProfileConfiguration } from "modules/Automation/actions";
import {
  ControlNameEnum,
  ISelectedTemplate,
  IShareProfileConfigurations,
  IShareProfileSignature,
  IShareProfileTemplate,
  ITemplateConfigurationData,
} from "../../interfaces";
import { RootState } from "store";
import { ValidateEmail } from "utils";

interface IConfiguration {
  isVisible: boolean;
  handleCancel: () => void;
}

const Configuration: React.FC<IConfiguration> = (props: IConfiguration) => {
  // Props
  const { isVisible, handleCancel } = props;

  // Redux States
  const shareProfileTemplates: IShareProfileTemplate[] = useSelector(
    (state: RootState) => state.automation.emails.shareProfileTemplates
  );
  const shareProfileConfigurationsData = useSelector(
    (state: RootState) => state.automation.workflow.shareProfileConfigurationsData
  );
  const shareProfileTemplatesConfigurationData: ITemplateConfigurationData = useSelector(
    (state: RootState) => state.automation.modals.shareProfileTemplatesData
  );
  const senderEmails = useSelector((state: RootState) => state.automation.workflow.senderEmails);
  const nodeId = useSelector((state: RootState) => state.automation.modals.addAction.id);
  const itemData = useSelector((state: RootState) => state.automation.workflow.flow[nodeId]?.detail);
  // Local States
  const [ellipsisState, setEllipsistate] = useState(false);
  const [templatesState, setTemplatesState] = useState<any[]>([]);
  const [templatesConfigurationState, setTemplatesConfigurationState] = useState<ISelectedTemplate[]>([]);
  const [configObject, setConfigObject] = useState<IShareProfileConfigurations>({
    selectedTemplate: {
      value: "Select a template",
      label: "Select a template",
    },
    selectedPersonalityMetrics: [],
    senderName: "",
    sendFrom: "Select email",
    emailSubject: "",
    replyTo: "",
    initials: "",
    signature: "Select signature",
    sendPlatform: 0,
    selectedConfigurations: {
      value: "Select a template",
      label: "Select a template",
    },
  });
  const [emailIsValid, setEmailIsValid] = useState(true);
  const [showConfigDataEmail, setShowConfigDataEmail] = useState(true);
  const [senderEmailsList, setSenderEmailsList] = useState<any[]>([]);

  // Local Variables
  const dispatch = useDispatch();
  const { Paragraph } = Typography;
  const { Option } = Select;
  const { TextArea } = AntdInput;

  // Component Logic
  useEffect(() => {
    if (senderEmails && shareProfileConfigurationsData) {
      setSenderEmailsList(senderEmails);
      senderEmails.map((emailObj) => {
        if (emailObj?.domain === shareProfileConfigurationsData?.sender_from?.data[0])
          setShowConfigDataEmail(false);
      });
    }
  }, [senderEmails, shareProfileConfigurationsData]);

  useEffect(() => {
    // if nodeId is empty thats mean user want to add share profile email
    // configurations equal to undefined means user want to change the simple email to share profile email
    if (isVisible && (!nodeId || itemData?.configurations === undefined)) {
      setConfigObject({
        selectedTemplate: {
          value: "Select a template",
          label: "Select a template",
        },
        selectedPersonalityMetrics: [],
        senderName: shareProfileConfigurationsData?.sender_name?.data,
        sendFrom: shareProfileConfigurationsData?.sender_from?.data[0],
        emailSubject: "",
        replyTo: shareProfileConfigurationsData?.reply_to?.data[0] ?? "",
        initials: "",
        signature: "Select signature",
        sendPlatform: 0,
        selectedConfigurations: {
          value: "Select a template",
          label: "Select a template",
        },
      });
    } else if (isVisible && nodeId) {
      let data = itemData.configurations;
      setConfigObject({
        selectedTemplate: data.selectedTemplate,
        selectedPersonalityMetrics: data.selectedPersonalityMetrics,
        senderName: data.senderName,
        sendFrom: data.sendFrom,
        emailSubject: data.emailSubject,
        replyTo: data.replyTo,
        initials: data.initials,
        signature: data.signature,
        sendPlatform: data.sendPlatform,
        selectedConfigurations: data.selectedConfigurations,
      });
    }
  }, [isVisible]);

  useEffect(() => {
    dispatch(saveShareProfileConfiguration(configObject));
  }, [configObject]);

  useEffect(() => {
    if (shareProfileTemplates) {
      setTemplatesState(shareProfileTemplates);
    }
  }, [shareProfileTemplates]);

  const populateConfigurations = (selectedOption: any) => {
    let value = selectedOption?.value;
    let selectedData = shareProfileTemplatesConfigurationData[value];
    let temp_config_data = selectedData?.template_configurations;
    if (temp_config_data) {
      let object = {
        selectedPersonalityMetrics: temp_config_data?.personality_metrics?.data ?? [],
        senderName: temp_config_data?.sender_name?.data,
        sendFrom: temp_config_data?.sender_from?.data[0] ?? "",
        emailSubject: temp_config_data?.subject?.data,
        replyTo: temp_config_data?.reply_to?.data[0] ?? "",
        initials: temp_config_data?.initial_text?.data,
        signature: temp_config_data?.signature?.data.id,
        sendPlatform: temp_config_data?.server?.data === "Amazon" ? 1 : 2,
        selectedConfigurations: selectedOption,
      };

      setConfigObject({ ...configObject, ...object });
    }
  };

  useEffect(() => {
    if (Object.keys(shareProfileTemplatesConfigurationData).length > 0) {
      let titles = Object.keys(shareProfileTemplatesConfigurationData).map((key) => ({
        value: key,
        label: shareProfileTemplatesConfigurationData[key].title,
      }));
      setTemplatesConfigurationState(titles);
    }
  }, [senderEmails]);

  const saveButtonClickHandler = () => {
    if (ValidateEmail(configObject.replyTo)) {
      setEmailIsValid(true);
      dispatch(shareProfileConfigurationModal(false));
    } else {
      setEmailIsValid(false);
    }
  };
  const conditionSelectHandler = (selectedOption: ISelectedTemplate) => {
    setConfigObject({ ...configObject, selectedTemplate: selectedOption });
  };

  const templateConditionSelectHandler = (selectedOption: any) => {
    populateConfigurations(selectedOption);
  };

  const personalityMetricsHandler = (isChecked: boolean, metricName: string) => {
    if (isChecked) {
      setConfigObject({
        ...configObject,
        selectedPersonalityMetrics: [...configObject.selectedPersonalityMetrics, metricName],
      });
    } else {
      const updatedIds: string[] = configObject.selectedPersonalityMetrics.filter(
        (metric) => metric !== metricName
      );
      setConfigObject({
        ...configObject,
        selectedPersonalityMetrics: updatedIds,
      });
    }
  };

  const sendWithChangehandler = (id: number) => {
    setConfigObject({
      ...configObject,
      sendPlatform: id,
    });
  };

  const senderNameChangeHandler = (value: string) => {
    setConfigObject({
      ...configObject,
      senderName: value,
    });
  };

  const sendFromChangeHandler = (value: string) => {
    setConfigObject({
      ...configObject,
      sendFrom: value,
    });
  };

  const emailSubjectChangeHandler = (value: string) => {
    setConfigObject({
      ...configObject,
      emailSubject: value,
    });
  };

  const replyToChangeHandler = (value: string) => {
    setConfigObject({
      ...configObject,
      replyTo: value,
    });
    if (ValidateEmail(value)) {
      setEmailIsValid(true);
    } else {
      setEmailIsValid(false);
    }
  };

  const initialsChangeHandler = (value: string) => {
    setConfigObject({
      ...configObject,
      initials: value,
    });
  };

  const signatureChangeHandler = (value: IShareProfileSignature | string) => {
    setConfigObject({
      ...configObject,
      signature: value,
    });
  };

  return (
    <StyledModal
      centered
      visible={isVisible}
      onCancel={handleCancel}
      footer={null}
      closeIcon={<Cross />}
      width={980}
      wrapClassName="workflow-modal"
      title="Configurations"
      bodyStyle={{ padding: "0px" }}
      maskClosable={false}
    >
      <Wrapper>
        <div className="configuration-secton">
          <form>
            <Row gutter={[32, 0]}>
              <Col span={12} className="condition-selector">
                <label className="config-label">Share Profile Template *</label>
                <SelectWithIcon
                  options={templatesState}
                  onChange={conditionSelectHandler}
                  value={configObject.selectedTemplate}
                  menuWidth={278}
                />
              </Col>
              <Col span={12} className="condition-selector">
                <label className="config-label">Template Configurations </label>
                <SelectWithIcon
                  options={templatesConfigurationState}
                  onChange={templateConditionSelectHandler}
                  value={configObject.selectedConfigurations}
                  menuWidth={278}
                />
              </Col>
            </Row>
            <div className="metrics">
              <h4>Personality Traits *</h4>
              <ul>
                {shareProfileConfigurationsData?.personality_metrics?.data?.map((itemName: any, index: number) => (
                  <li key={index}>
                    <label className="parent-label">
                      <Checkbox
                        checked={configObject?.selectedPersonalityMetrics?.includes(itemName)}
                        onChange={(e: any) => personalityMetricsHandler(e.target.checked, itemName)}
                      />
                      <Tooltip placement="top" title={ellipsisState ? itemName : undefined}>
                        <Paragraph className="list-name" ellipsis={{ onEllipsis: setEllipsistate }}>
                          {itemName}
                        </Paragraph>
                      </Tooltip>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
            <div className="form-parent">
              <div className="form-fields">
                <div>
                  <Input
                    label="Sender Name *"
                    labelProps={{ fontFamily: "'Roboto Slab', serif;" }}
                    name="senderName"
                    type="text"
                    placeholder="Start typing the name of a sender person"
                    value={configObject.senderName}
                    onChange={(e: any) => senderNameChangeHandler(e.target.value)}
                  />
                </div>
                <div className="input-box">
                  <label className="config-label">Send From: *</label>
                  <Select
                    defaultValue="Select Email"
                    className={""}
                    style={{ width: "100%" }}
                    listHeight={140}
                    popupClassName="send-from"
                    getPopupContainer={() => document.querySelectorAll(".form-parent")[0] as HTMLElement}
                    value={configObject.sendFrom}
                    onChange={(value) => sendFromChangeHandler(value)}
                  >
                    {showConfigDataEmail &&
                      shareProfileConfigurationsData?.sender_from?.data?.map((item: any) => {
                        return (
                          <Option key={item} value={item}>
                            {item}
                          </Option>
                        );
                      })}
                    {senderEmailsList?.map((item: any) => (
                      <Option key={item.id} value={item.domain}>
                        {item.domain}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="form-fields">
                <div>
                  <Input
                    label="Email Subject: *"
                    labelProps={{ fontFamily: "'Roboto Slab', serif;" }}
                    name="emailSubject"
                    type="text"
                    placeholder="Start typing your email subject here…"
                    onChange={(e: any) => emailSubjectChangeHandler(e.target.value)}
                    value={configObject.emailSubject}
                  />
                </div>

                <div>
                  <Input
                    label="Reply-To: *"
                    labelProps={{ fontFamily: "'Roboto Slab', serif;" }}
                    name="replyTo"
                    type="text"
                    placeholder="Start typing your reply-to email here…"
                    onChange={(e: any) => replyToChangeHandler(e.target.value)}
                    value={configObject.replyTo}
                    error={!emailIsValid}
                    errorMsg={"Please enter a valid email address*"}
                  />
                </div>
              </div>
              <div className="form-fields">
                <label className="config-label">Email Body</label>
                <TextArea
                  autoSize={{ minRows: 5, maxRows: 7 }}
                  placeholder="Start typing your description..."
                  rows={5}
                  className="round-field"
                  id={"description-"}
                  value={configObject.initials}
                  onChange={(e) => initialsChangeHandler(e.target.value)}
                />
              </div>
              <div className="form-fields">
                <div className="input-box">
                  <label className="config-label">Signature: *</label>
                  <Select
                    className={""}
                    style={{ width: "100%" }}
                    listHeight={140}
                    popupClassName="signature"
                    getPopupContainer={() => document.querySelectorAll(".form-parent")[0] as HTMLElement}
                    value={configObject.signature}
                    onChange={(value) => signatureChangeHandler(value)}
                  >
                    {shareProfileConfigurationsData?.signature?.data?.map((signature: IShareProfileSignature) => (
                      <Option key={signature.id} value={signature.id}>
                        {signature.title}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="">
                  <label className="config-label">Send email with *</label>
                  <Radio.Group
                    onChange={(e) => sendWithChangehandler(e.target.value)}
                    name="sendPlatform"
                    className={``}
                    value={configObject.sendPlatform}
                  >
                    <Space direction="vertical">
                      <Radio className={"email-vendor"} value={1}>
                        Amazon
                      </Radio>
                      <Radio className={"email-vendor"} value={2}>
                        SendGrid
                      </Radio>
                    </Space>
                  </Radio.Group>
                </div>
              </div>
            </div>
          </form>
          <div className="d-flex justify-content-end save-btn">
            <SmallButton
              disabled={
                configObject.selectedTemplate.value === "Select a template" ||
                configObject.selectedPersonalityMetrics?.length === 0 ||
                configObject.senderName?.trim() === "" ||
                configObject.sendFrom === "Select email" ||
                configObject.replyTo?.trim() === "" ||
                configObject.emailSubject?.trim() === "" ||
                configObject.signature === "Select signature" ||
                configObject.sendPlatform === 0 ||
                !emailIsValid
              }
              title="Save"
              type="submit"
              onClick={saveButtonClickHandler}
              form={ControlNameEnum.SEND_EMAIL}
            />
          </div>
        </div>
      </Wrapper>
    </StyledModal>
  );
};

export default Configuration;

const Wrapper = styled.div`
  .configuration-secton {
    padding: 15px 24px 0 30px;
    height: 618px;
    overflow: auto;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 516px;
    }
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 20px;
      margin-right: 5px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 40px;
      }
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    .condition-selector {
      padding-right: 24px !important;
      > div {
        > div {
          > .qa-control {
            width: 100%;
            height: 36px;
          }
        }
      }
    }
    label,
    .ant-typography {
      font-family: "Roboto Slab", serif;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: -0.4px;
      line-height: 18px;
      color: #424b50;
      margin-bottom: 8px;
      margin-right: 25px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 12px;
      }
    }
  }
  .metrics {
    margin-top: 24px;
    h4 {
      /* font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 18px;
      letter-spacing: -0.333333px;
      color: #424b50;
      margin-bottom: 0; */

      color: #424b50;
      display: block;
      /* margin: 23px 0 8px 0; */
      font-size: 18px;
      font-family: "Roboto Slab", serif;
      font-weight: 600;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 14px;
      }
    }
    ul {
      list-style-type: none;
      margin: 0px;
      padding: 0px;
      display: grid;
      grid-template-columns: auto auto 217px;
      li {
        .parent-label {
          display: flex;
          align-items: center;
          min-height: 36px;
          flex: 1 1 33.33%;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            min-height: 24px;
          }
          > div:nth-child(1) {
            margin-top: 0;
            transform: translateY(2px);
          }
          label,
          .ant-typography {
            font-family: "robotomedium";
            font-weight: 500;
            font-size: 16px;
            letter-spacing: -0.4px;
            line-height: 18px;
            color: #7e7e7e;
            margin-bottom: 0;
            margin-right: 25px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              line-height: 18px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .form-parent {
    position: relative;
    .form-fields {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      > div {
        flex: 0 0 50%;
        padding: 0 24px 0 0;
      }
      label {
        color: #424b50;
        display: block;
        margin: 23px 0 8px 0;
        font-size: 18px;
        font-family: "Roboto Slab", serif;
        font-weight: 600;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
      .ant-select-selector {
        height: 44px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 36px;
        }
      }
      input,
      .round-field {
        color: #424b50;
        border-radius: 10px;
        padding: 8px 18px;
        font-size: 16px;
        line-height: 26px;
        font-weight: 400;
        border: 1px solid #dadada;
        font-family: "robotoregular";
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
          height: 36px;
        }
      }
      .ant-radio-group {
        .ant-radio-wrapper {
          margin: 8px 48px 8px 0;
          display: flex;
        }
      }
    }
    .ant-select-arrow {
      .anticon {
        background: url(${DownAngle});
        background-repeat: no-repeat;
        background-position: center;
        svg {
          opacity: 0;
        }
      }
      &:before {
        margin-top: -4px;
        content: "" !important;
        border-left: 1px solid #dddddd;
        display: block;
        height: 22px;
        margin-right: 8px;
        margin-left: -12px;
      }
    }
  }
  .save-btn {
    padding: 24px 0 28px 24px;
  }
`;

const StyledModal = styled(Modal)`
  height: 700px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    height: 600px;
  }

  .ant-modal-content {
    .ant-modal-header {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .ant-modal-title {
        margin: 0;
        font-family: "Roboto";
        color: #424b50;
        font-weight: 500;
        font-size: 30px;
        line-height: 22px;
        word-wrap: break-word;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 24px;
        }
      }
    }
    border-radius: 8px;
    box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.0821427);
  }
`;
